import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_SUBORDER_CUSTOMER_METRIC } from '../interfaces/ISuborderCustomer';

class AnalyticSuborderCustomerService extends EntityApiService<any> {
  searchByMetric = (metric: ANALYTIC_SUBORDER_CUSTOMER_METRIC, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));
  };
}

/**
 * NOTA (DEV): para probar SOLO este servicio contra un ms-analytics local, define
 * REACT_APP_ANALYTICS_URL=http://localhost:8080 en tu .env. Al ser una URL absoluta,
 * axios ignora el REACT_APP_BACKEND_URL global únicamente para este servicio.
 * TODO PROD: dejar la variable vacía para que use el gateway global (path relativo).
 */
const ANALYTICS_BASE_URL = process.env.REACT_APP_ANALYTICS_URL || '';

export default new AnalyticSuborderCustomerService(
  `${ANALYTICS_BASE_URL}/ms-analytics/api/v1/suborder-complete-customer-analytics`,
);
